// Prev/next buttons for scroll-snap lists: <div data-carousel-nav="list-id">
// with two buttons (data-dir="-1" and "1"). The list scrolls without them;
// they stay hidden until this runs.
export default function carousels() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-carousel-nav]').forEach((nav) => {
    const list = document.getElementById(nav.dataset.carouselNav);
    if (!list || !list.firstElementChild) return;
    const [prev, next] = nav.querySelectorAll('button');

    // Scroll by as many whole items as fit in the visible width.
    const step = () => {
      const item = list.firstElementChild;
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      const width = item.offsetWidth + gap;
      return Math.max(1, Math.floor(list.clientWidth / width)) * width;
    };

    const update = () => {
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
    };

    [prev, next].forEach((button) => {
      button.addEventListener('click', () => {
        list.scrollBy({
          left: Number(button.dataset.dir) * step(),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      });
    });

    list.addEventListener('scroll', update, { passive: true });
    nav.hidden = false;
    // The carousel styles live in the non-blocking v2-rest.css, which often
    // applies after this runs: until then the list doesn't scroll and both
    // buttons would stay disabled. Re-check whenever the list changes size
    // (styles arriving, window resize). The observer also fires once right
    // after the first layout, which sets the initial state: calling update()
    // here would force a layout of the whole page before the first paint.
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(list);
    } else {
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    }
  });
}
